import React from "react";
import { CollapsibleFormSection } from "../../common/CollapsibleFormSection";
import { FormTextarea } from "../../common/FormTextarea";
import { FormInput } from "../../common/FormInput";
import { SmartGoalSelector } from "../../common/SmartGoalSelector";
import { PersonalisedLearningSupportPlanData } from "src/models/form-types";

interface FormValidation {
  isPurposeValid: boolean;
  isLearningValid: boolean;
  isAdditionalInfoValid: boolean;
  isAdjustmentLevelValid: boolean;
  isStudentInfoValid: boolean;
}

interface OtherGoalSectionProps {
  formData: PersonalisedLearningSupportPlanData;
  onTextChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  goals: any[];
  isLoading: boolean;
  error: string | null;
  onGenerateGoals: () => Promise<void>;
  onGoalSelect: (goal: string) => void;
  selectedGoal: string | null;
  isFormValid: boolean;
  formValidation: FormValidation;
  className?: string;
}

export const OtherGoalSection: React.FC<OtherGoalSectionProps> = ({
  formData,
  onTextChange,
  goals,
  isLoading,
  error,
  onGenerateGoals,
  onGoalSelect,
  selectedGoal,
  isFormValid,
  formValidation,
  className,
}) => {
  return (
    <CollapsibleFormSection
      title="Optional Learning Goal 3: Other KLA, personal, or socioemotional"
      className={className}
    >
      <FormInput
        id="otherGoalType"
        name="otherGoalType"
        label="Goal Type (e.g., Science, Social Skills, Emotional Regulation)"
        value={formData.otherGoalType}
        onChange={onTextChange}
        width="full"
      />

      <FormTextarea
        id="otherGoalInfo"
        name="otherGoalInfo"
        label="Give me some information about the student's current level in this area. This will help generate appropriate goals."
        value={formData.otherGoalInfo}
        onChange={onTextChange}
        rows={4}
      />

      <SmartGoalSelector
        goals={goals.map((goal, index) => ({ id: index + 1, text: goal.text }))}
        isLoading={isLoading}
        error={error}
        onGenerateGoals={onGenerateGoals}
        onGoalSelect={onGoalSelect}
        isFormValid={
          isFormValid &&
          formData.otherGoalInfo.trim() !== "" &&
          formData.otherGoalType.trim() !== ""
        }
        formValidation={formValidation}
        invalidHintTitle="Please complete these required fields (Goal 3 is optional):"
        invalidHintItems={[
          ...(formData.otherGoalType.trim() === "" ? ["Goal Type"] : []),
          ...(formData.otherGoalInfo.trim() === ""
            ? ["Student's current level"]
            : []),
        ]}
        radioGroupName="otherGoals"
      />
    </CollapsibleFormSection>
  );
};
